import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import styled from "styled-components";
// Assets
// import ContactImg1 from "../../assets/img/contact-1.png";
// import ContactImg2 from "../../assets/img/contact-2.png";
// import ContactImg3 from "../../assets/img/contact-3.png";

import ContactImg1 from "../../assets/jpg_png/home17.jpg";
import ContactImg2 from "../../assets/jpg_png/home18.jpg";
import ContactImg3 from "../../assets/jpg_png/home19.jpg";

import { BsPhoneFill } from "react-icons/bs";
import { HiPhone, HiOutlineMailOpen } from "react-icons/hi";

//Css
import "../../style/TopNavbar.css";

export default function Contact() {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_3khbax3",
        "template_vceq75s",
        form.current,
        "jXgg4xS_Now8hMQpQ"
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Message Sent Successfully");
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <Wrapper id="contact">
      <div className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold" style={{ color: "#9E9D24" }}>
              Let's get in touch
            </h1>
            <p className="font16 contact-detals">
              <h4>Contact Us</h4>
              <span>
                Give Us a call : <a href="tel:6303435214">+91 6303435214</a>
              </span>

              <span>
                Email:
                <a href="mailto:nliteinteriors@gmail.com">
                  nliteinteriors@gmail.com
                </a>
              </span>
            </p>
            {/* <p className="font13">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut
              <br />
              labore et dolore magna aliquyam erat, sed diam voluptua.
            </p> */}
          </HeaderInfo>
          <div className="row" style={{ paddingBottom: "30px" }}>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form ref={form} onSubmit={sendEmail}>
                <label className="font13">First name:</label>
                <input
                  type="text"
                  id="user_name"
                  name="user_name"
                  className="font20"
                />
                <label className="font13">Email:</label>
                <input
                  type="email"
                  id="user_email"
                  name="user_email"
                  className="font20"
                />
                <label className="font13">Subject:</label>
                {/* <input type="text" id="subject" name="subject" className="font20 extraBold" /> */}
                <textarea
                  rows="4"
                  cols="50"
                  type="text"
                  id="message"
                  name="message"
                  className="font20"
                />

                <button
                  type="submit"
                  value="Send"
                  className="pointer animate radius8"
                  style={{ maxWidth: "220px" }}
                >
                  Send
                </button>
              </Form>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 flex">
              <div
                style={{ width: "50%" }}
                className="flexNullCenter flexColumn"
              >
                <ContactImgBox>
                  <img
                    src={ContactImg3}
                    alt="office"
                    className="radius6 ContactImg1"
                  />
                </ContactImgBox>
                <ContactImgBox>
                  <img
                    src={ContactImg2}
                    alt="office"
                    className="radius6 ContactImg2"
                  />
                </ContactImgBox>
              </div>
              <div style={{ width: "50%" }}>
                <div style={{ marginTop: "100px" }}>
                  <img
                    src={ContactImg1}
                    alt="office"
                    className="radius6 ContactImg3"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  padding: 70px 0 0px 0;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Form = styled.form`
  padding: 70px 0 30px 0;
  label {
    color: #111;
    font-size: 16px;
    font-weight: 600;
  }
  input,
  textarea {
    width: 100%;
    background-color: transparent;
    border: 0px;
    outline: none;
    box-shadow: none;
    border-bottom: 2px solid #707070;
    height: 30px;
    margin-bottom: 30px;
    font-size: 16px;
  }
  textarea {
    min-height: 100px;
  }
  @media (max-width: 860px) {
    padding: 30px 0;
  }
  button {
    border: 1px solid #7620ff;
    background-color: #7620ff;
    width: 100%;
    padding: 15px;
    outline: none;
    color: #fff;
    font-size: 16px;
    :hover {
      background-color: #580cd2;
      border: 1px solid #7620ff;
      color: #fff;
    }
  }
`;
// const ButtonInput = styled.input`

//   @media (max-width: 991px) {
//     margin: 0 auto;
//   }
// `;
const ContactImgBox = styled.div`
  max-width: 180px;
  align-self: flex-end;
  margin: 10px 30px 10px 0;
  .ContactImg1 {
    width: 100%;
    height: 204px;
  }
  .ContactImg2 {
    width: 100%;
    height: 295px;
  }
`;
const SumbitWrapper = styled.div`
  @media (max-width: 991px) {
    width: 100%;
    margin-bottom: 50px;
  }
`;
